import type { Location } from 'history';
import queryString, { type ParseOptions, type StringifyOptions } from 'query-string';

const urlParseOptions: ParseOptions & StringifyOptions = {
  arrayFormat: 'bracket-separator',
  arrayFormatSeparator: ',',
  parseNumbers: true,
};

export enum UrlKeys {
  BatchRequestKey = 'b',
  Catalog = 'c',
  Categories = 'cat',
  DateRange = 'dr',
  Dialog = 'd',
  Organization = 'o',
  SimulatedPrice = 'sp',
  SwapCrossCatalog = 'scc',
  SwapSameSupplier = 'ssup',
  SwapSimilarityThreshold = 'sst',
  SwapSavingsPercentageRange = 'sspr',
  SwapSortBy = 'ssb',
  SwapTypeAcceptance = 'sta',
  SwapUnit = 'su',
  Taxonomy = 't',
  OnlyPositiveSavings = 'onlyPositiveSavings',
  ClientEntities = 'clientEntities',
}

export function parseUrlQuery(location: Location) {
  return queryString.parse(location.search, {
    arrayFormat: 'bracket-separator',
    arrayFormatSeparator: ',',
    parseNumbers: true,
  });
}

export function stringifyToQueryUrl(object: Record<string, unknown>) {
  return queryString
    .stringify(object, { arrayFormat: 'bracket-separator', arrayFormatSeparator: ',' })
    .replaceAll('?', '');
}

export function pickParamFromUrl(location: Location, params: string[]): string;
export function pickParamFromUrl(
  location: Location,
  filter: (key: string, value: string | boolean | number) => boolean,
): string;

export function pickParamFromUrl(
  location: Location,
  params: readonly string[] | ((key: string, value: string | boolean | number) => boolean),
) {
  let result: string;
  if (Array.isArray(params)) {
    result = queryString.pick(location.search, params, urlParseOptions);
  } else {
    result = queryString.pick(location.search, params as (key: string, value: string | boolean | number) => boolean, {
      ...urlParseOptions,
      parseBooleans: true,
    });
  }
  return result.replaceAll('?', '');
}

export function excludeParamsFromUrl(location: Location, params: string[]): string;
export function excludeParamsFromUrl(
  location: Location,
  filter: (key: string, value: string | boolean | number) => boolean,
): string;

export function excludeParamsFromUrl(
  location: Location,
  params: readonly string[] | ((key: string, value: string | boolean | number) => boolean),
) {
  let result: string;
  if (Array.isArray(params)) {
    result = queryString.exclude(location.search, params, {
      arrayFormat: 'bracket-separator',
      arrayFormatSeparator: ',',
      parseNumbers: true,
    });
  } else {
    result = queryString.exclude(
      location.search,
      params as (key: string, value: string | boolean | number) => boolean,
      { arrayFormat: 'bracket-separator', arrayFormatSeparator: ',', parseNumbers: true },
    );
  }
  return result.replaceAll('?', '');
}
